export default "__VITE_ASSET__DvIoI9uc__"